import * as React from 'react';
import { useTheme } from 'styled-components';

export interface LogoProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
  color?: string;
}

export const Logo: React.FC<LogoProps> = ({ className, color, ...props }) => {
  const theme = useTheme();

  const getColor = (color: any) => {
    switch (color) {
      case 'dark':
        return theme.colors.accentHover;
      case 'light':
        return theme.colors.white;
      case 'red':
        return theme.colors.accent;
      case 'pink':
        return theme.colors.pink;
      default:
        return theme.colors.white;
    }
  };
  return (
    <svg
      width={104}
      height={25}
      viewBox="0 0 104 25"
      className={className || ''}
      {...props}
    >
      <g>
        <path
          fill={getColor(color)}
          d="M39.82,0l-4.82,4.84v13.35c0,4.06,1.82,6.81,7.16,6.81,1.3,0,2.6-.13,3.91-.52v-3.8c-.91,.26-1.82,.39-2.73,.39-2.34,0-3.52-1.05-3.52-3.53v-7.33h6.25V5.76h-6.25V0Z"
        />
        <path
          fill={getColor(color)}
          d="M52.97,11.26V6.41h-4.3V24.87h4.69v-7.2c-.13-2.09,.39-4.19,1.82-5.76,1.17-1.18,2.86-1.7,4.43-1.57,.52,0,.91,0,1.43,.13V6.02c-.39-.13-.91-.13-1.3-.13-3.25,0-5.99,2.23-6.77,5.37Z"
        />
        <path
          fill={getColor(color)}
          d="M81.87,24.35V13.09c0-5.37-2.99-7.85-9.5-7.85-5.86,0-9.63,2.62-10.15,6.68h4.95c.26-2.23,2.08-3.4,5.08-3.4s4.69,1.31,4.69,3.93v.39l-6.51,.52c-3.38,.39-5.34,.92-6.64,1.7-1.43,.92-2.34,2.49-2.21,4.19,0,3.4,2.86,5.63,7.42,5.63,4.04,0,6.9-1.44,8.2-3.93v3.4h4.69Zm-4.69-7.85c0,3.14-2.6,5.24-6.51,5.24-2.6,0-4.04-.92-4.04-2.62s1.17-2.62,4.3-2.88l6.25-.65v.92Z"
        />
        <path
          fill={getColor(color)}
          d="M94.11,8.77c2.99,0,4.95,1.44,5.47,3.93h0l4.43-1.96c-1.3-3.53-4.82-5.5-9.76-5.5-6.77,0-11.07,3.8-11.07,9.82s4.3,9.82,10.94,9.82c4.95,0,8.59-2.09,9.89-5.63l-4.43-1.96c-.52,2.49-2.99,4.19-5.47,3.93-3.65,0-5.99-2.36-5.99-6.28s2.21-6.15,5.99-6.15Z"
        />
      </g>
      <path
        fill={getColor(color)}
        d="M22.5,11.5L11,0V11.5L0,0V19.5l5.47,5.5,.03-11.5,11.5,11.5V13.5l11,11.5V5.5L22.5,0V11.5Z"
      />
    </svg>
  );
};

export default Logo;
